import React, {useState} from "react";
import {ClipBoardService} from "../../../service/ClipBoardService";
import {useTranslation} from "react-i18next";

export const DKIMGeneratorForm = () => {
    const [dkimSettings, setDkimSettings] = useState({
        selector: '',
        domain: '',
        publicKey: ''
    });

    const [dnsEntry, setDnsEntry] = useState('');
    const clipboarService = new ClipBoardService();
    const {t} = useTranslation();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setDkimSettings(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const generateDkimRecord = ({ selector, domain, publicKey }) => {
        if (!selector || !domain || !publicKey) return '';
        return `${selector}._domainkey.${domain} IN TXT "v=DKIM1; k=rsa; p=${publicKey.trim()}";`;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const record = generateDkimRecord(dkimSettings);
        setDnsEntry(record);
    };

    return (
        <div className={"container-fluid"}>
            <form onSubmit={handleSubmit}
                  className="mb-4 bg-white p-4 p-md-5 rounded rounded-3 shadow d-flex flex-column">

                <div className="mb-3">
                    <label htmlFor="selector" className="form-label d-flex align-items-center">
                        {t("pages.dkimGenerator.form.selector.title")}
                        <i className="bi bi-info-circle ms-2"
                           data-bs-toggle="tooltip"
                           data-bs-placement="right"
                           title={t("pages.dkimGenerator.form.selector.info")}
                           style={{cursor: 'pointer'}}></i>
                    </label>
                    <input
                        type="text"
                        id="selector"
                        name="selector"
                        value={dkimSettings.selector}
                        onChange={handleChange}
                        className="form-control"
                        placeholder={t("pages.dkimGenerator.form.selector.placeholder")}
                    />
                </div>

                <div className="mb-3">
                    <label htmlFor="domain" className="form-label d-flex align-items-center">
                        {t("pages.dkimGenerator.form.domain.title")}
                        <i className="bi bi-info-circle ms-2"
                           data-bs-toggle="tooltip"
                           data-bs-placement="right"
                           title={t("pages.dkimGenerator.form.domain.info")}
                           style={{cursor: 'pointer'}}></i>
                    </label>
                    <input
                        type="text"
                        id="domain"
                        name="domain"
                        value={dkimSettings.domain}
                        onChange={handleChange}
                        className="form-control"
                        placeholder={t("pages.dkimGenerator.form.domain.placeholder")}
                    />
                </div>

                <div className="mb-3">
                    <label htmlFor="publicKey" className="form-label d-flex align-items-center">
                        {t("pages.dkimGenerator.form.publicKey.title")}
                        <i className="bi bi-info-circle ms-2"
                           data-bs-toggle="tooltip"
                           data-bs-placement="right"
                           title={t("pages.dkimGenerator.form.publicKey.info")}
                           style={{cursor: 'pointer'}}></i>
                    </label>
                    <textarea
                        id="publicKey"
                        name="publicKey"
                        value={dkimSettings.publicKey}
                        onChange={handleChange}
                        className="form-control"
                        rows="4"
                        placeholder={t("pages.dkimGenerator.form.publicKey.placeholder")}
                    />
                </div>

                <div className="mb-3 text-end">
                    <button type="submit" className="btn btn-primary text-white">
                        {t("pages.dkimGenerator.form.generate")}
                    </button>
                </div>

                {dnsEntry && (
                    <div className={"alert alert-success"}>
                        <h4>{t("pages.dkimGenerator.form.result.title")}</h4>
                        <p>{t("pages.dkimGenerator.form.result.subTitle")}</p>
                        <hr/>
                        <div className="d-flex justify-content-between flex-wrap">
                            <p className="font-monospace" style={{ wordBreak: "break-all" }}>{dnsEntry}</p>
                            <div>
                                <button className="btn btn-primary text-white" onClick={() => clipboarService.handleCopy(dnsEntry)}>
                                    {t("pages.dkimGenerator.form.result.copy")}
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </form>
        </div>
    );
};
